import { render, staticRenderFns } from "./CustomBtnIcon.vue?vue&type=template&id=6491ad74"
import script from "./CustomBtnIcon.vue?vue&type=script&lang=js"
export * from "./CustomBtnIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports